import { render, staticRenderFns } from "./EmployeesCardsPage.vue?vue&type=template&id=ad45d6a0&scoped=true&"
import script from "./EmployeesCardsPage.vue?vue&type=script&lang=js&"
export * from "./EmployeesCardsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad45d6a0",
  null
  
)

export default component.exports